import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "mt-4 py-2 py-lg-4 ps-4 ps-xl-60" };
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-12 text-gray-600" };
const _hoisted_3 = { class: "d-flex gap-20 align-items-center" };
const _hoisted_4 = { class: "c-qa-avatar rounded-pill overflow-hidden" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "d-flex gap-20 align-items-center" };
const _hoisted_7 = { class: "d-flex align-items-center" };
const _hoisted_8 = ["data-rated", "data-id"];
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "d-flex gap-12 justify-content-end mt-12" };
const _hoisted_12 = ["disabled"];
import { DateTime } from 'ts-luxon';
import { onMounted, ref } from 'vue';
import DOMPurify from 'dompurify';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReplyItem',
    props: {
        reply: {}
    },
    emits: ['edit', 'delete'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const favoriteBtn = ref();
        const ratingCount = ref();
        const user = u.data('user');
        const enabledEditReply = ref(false);
        const content = ref(props.reply.content);
        const date = DateTime.fromISO(props.reply.created, { zone: 'UTC' })
            .setZone('Asia/Taipei')
            .toFormat('yyyy-MM-dd');
        const loading = ref(false);
        async function prepareCommentRatingCount(commentId) {
            const res = await u.$http.get('@ajax_lesson/prepareCommentRatingCount', {
                params: {
                    comment_id: commentId,
                }
            });
            const count = res.data.data;
            if (ratingCount.value) {
                ratingCount.value.innerHTML = count;
            }
        }
        async function deleteReply() {
            const v = await swal({
                text: '確定要刪除此回覆嗎？',
                buttons: {
                    cancel: {
                        text: "取消",
                        visible: true
                    },
                    confirm: {
                        text: "確定",
                        visible: true
                    },
                }
            });
            if (v) {
                emits('delete', props.reply);
            }
        }
        function postEditReply() {
            loading.value = true;
            emits('edit', content.value, props.reply);
            enabledEditReply.value = false;
            loading.value = false;
        }
        function prepareReply(reply) {
            const raw = reply?.replace(/\n/g, '<br>') ?? '';
            return DOMPurify.sanitize(raw);
        }
        onMounted(() => {
            favoriteBtn.value?.addEventListener('rated', async (e) => {
                const target = e.target;
                const id = target.dataset.id ?? '0';
                await prepareCommentRatingCount(id);
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("img", {
                                    src: _ctx.reply?.user.avatar ? _ctx.reply?.user.avatar : 'assets/images/front/demo/avatar.svg',
                                    alt: _ctx.reply.user.nickname !== '' ? _ctx.reply.user.nickname : '匿名',
                                    class: "w-100 h-100 object-fit-cover"
                                }, null, 8, _hoisted_5)
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.reply.user.nickname !== '' ? _ctx.reply.user.nickname : '匿名') + " ", 1),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "d-none d-md-inline" }, "|", -1)),
                            _cache[4] || (_cache[4] = _createElementVNode("br", { class: "d-md-none" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_unref(date)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("a", {
                                    href: "javascript://",
                                    class: "j-qa-favicon c-qa-favicon btn me-2 p-0",
                                    ref_key: "favoriteBtn",
                                    ref: favoriteBtn,
                                    "uni-rating-button": "",
                                    "data-rated": _ctx.reply.rated,
                                    "data-type": "comment",
                                    "data-id": _ctx.reply.id,
                                    "data-class-active": "",
                                    "data-class-inactive": "",
                                    "data-icon-active": "fas fa-heart",
                                    "data-icon-inactive": "far fa-heart",
                                    "data-title-active": "取消",
                                    "data-title-inactive": "讚"
                                }, _cache[5] || (_cache[5] = [
                                    _createElementVNode("i", null, null, -1)
                                ]), 8, _hoisted_8),
                                _createElementVNode("span", {
                                    class: "opacity-50",
                                    ref_key: "ratingCount",
                                    ref: ratingCount
                                }, _toDisplayString(_ctx.reply.rating_count), 513)
                            ]),
                            (_unref(user).id === _ctx.reply.userId)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: "javascript://",
                                    class: "link-gray-600",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (enabledEditReply.value = true))
                                }, " 編輯 "))
                                : _createCommentVNode("", true),
                            (_unref(user).id === _ctx.reply.userId)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: "javascript://",
                                    class: "link-gray-600",
                                    onClick: deleteReply
                                }, " 刪除 "))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (!enabledEditReply.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "mb-0",
                            innerHTML: prepareReply(_ctx.reply.content)
                        }, null, 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control",
                                placeholder: "提問內容",
                                rows: "3",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((content).value = $event))
                            }, null, 512), [
                                [_vModelText, content.value]
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("a", {
                                    class: _normalizeClass(["btn btn-outline-primary btn-sm", { 'disabled': loading.value }]),
                                    onClick: _cache[2] || (_cache[2] = ($event) => (enabledEditReply.value = false))
                                }, " 取消 ", 2),
                                _createElementVNode("button", {
                                    class: "btn btn-primary btn-sm",
                                    onClick: postEditReply,
                                    disabled: loading.value
                                }, " 送出 ", 8, _hoisted_12)
                            ])
                        ]))
                ])
            ]));
        };
    }
});
